import React, { forwardRef } from "react";
import { contactDetails } from "../Details";

export const Contact = forwardRef((props, ref) => {
  const { email, phone } = contactDetails;
  return (
    <main ref={ref} id="contact" className="container mx-auto max-width section pt-[6vw]">
      <h1 className="text-center text-2xl md:text-3xl lg:text-6xl text-dark-heading dark:text-light-heading font-semibold md:font-bold">
        For any questions please drop a mail
      </h1>
      <h3 className="text-center text-xl md:text-4xl lg:text-5xl text-gradient font-semibold md:font-bold pt-5 md:pt-10 md:pb-6">
        <a href={`mailto:${email}`} className="hover:text-gray-600">{email}</a>
      </h3>
      <span className="text-center text-content text-xl font-light block">or</span>
      <h3 className="text-center text-xl md:text-4xl lg:text-5xl text-gradient font-semibold md:font-bold pt-2 md:py-6">
        <a href={`tel:${phone}`} className="hover:text-gray-600">{phone}</a>
      </h3>
    </main>
  );
});